import { Link } from 'react-router-dom';

export default function CtaSection() {
  return (
    <section className="py-20 md:py-28 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Luxurious%20warm%20amber%20and%20sand%20abstract%20gradient%20with%20subtle%20organic%20flowing%20curves%20and%20delicate%20light%20particles%2C%20modern%20sophisticated%20editorial%20background%2C%20elegant%20minimalist%20design%20with%20soft%20golden%20glow%20effect%2C%20premium%20brand%20atmosphere%2C%20refined%20gentle%20color%20transitions%20from%20warm%20beige%20to%20deep%20caramel%2C%20no%20text%20no%20logos%20just%20atmospheric%20abstract%20elegance&width=1600&height=600&seq=cta-bg-v2-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-700/90 via-primary-800/80 to-primary-900/90"></div>
      </div>

      <div className="relative z-10 max-w-[800px] mx-auto px-6 md:px-10 text-center">
        <h2 className="font-heading text-4xl md:text-5xl font-bold text-background-50 tracking-tight leading-tight">
          Ready to Explore VigorBuy Spreadsheet?
        </h2>
        <p className="mt-5 text-base text-background-200 max-w-lg mx-auto leading-relaxed">
          Start discovering the latest resources, buying guides, and category comparisons today. Save time and shop smarter with organized product data.
        </p>
        <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-4 rounded-md bg-background-50 text-primary-700 text-sm font-semibold hover:bg-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            Explore Now
            <i className="ri-arrow-right-up-line text-base"></i>
          </a>
          <Link
            to="/vigorbuy-sheet-seo-guide"
            className="px-8 py-4 rounded-md bg-background-50/10 backdrop-blur-sm border border-background-50/30 text-background-50 text-sm font-semibold hover:bg-background-50/20 transition-all duration-200 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            Read Guide
            <i className="ri-book-open-line text-base"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}